<div class="observations-wrapper">
  <ng-container *ngIf="observationPeriod === PatientDataInfoPeriod.LAST_AVAILABLE">
    <app-observation-last-available [observations]="observations"></app-observation-last-available>
  </ng-container>

  <ng-container *ngIf="observationPeriod !== PatientDataInfoPeriod.LAST_AVAILABLE">
    <div class="observations-by-period">
      <ng-container *ngFor="let _ of [].constructor(numberOfPeriods); let periodIndex = index">
        <app-observation-single-period
          *ngIf="groupedObservations[periodIndex]"
          [date]="groupedObservations[periodIndex]?.date"
          [observations]="groupedObservations[periodIndex]?.observations"
        ></app-observation-single-period>
      </ng-container>

      <div *ngIf="groupedObservations.length === 0" class="no-observations">
        <span>{{ "widget.noData" | translate }}</span>
      </div>
    </div>
  </ng-container>
</div>
